export interface NominaModule {
  name: string;
  key: string;
  icon: string;
  path: string;
}

export const NOMINA_MODULES: NominaModule[] = [
  {
    name: "Bonos",
    key: "bonos",
    icon: "circle-dollar-to-slot",
    path: "/nomina/bonos"
  },
  {
    name: "Incapacidades",
    key: "incapacidades",
    icon: "user-injured",
    path: "/incapacidades"
  },
  {
    name: "Permisos",
    key: "permisos",
    icon: "calendar-check",
    path: "/permisos"
  },
  {
    name: "Vacaciones",
    key: "vacaciones",
    icon: "umbrella-beach",
    path: "/vacaciones"
  },
  {
    name: "Faltantes en caja",
    key: "faltantes-caja",
    icon: "money-check-dollar",
    path: "/faltantes-caja"
  },
  {
    name: "Quejas",
    key: "quejas",
    icon: "comment-dots",
    path: "/quejas"
  },
  {
    name: "Préstamos",
    key: "prestamos",
    icon: "hand-holding-dollar",
    path: "/prestamos"
  }
];
